import "@repo/ui/globals.css";
import { useEffect } from "react";
// import "@repo/client-portal/overrides.css";
// import "@/styles/collapsible.css";

import type { AppProps } from "next/app";
import { QueryClientProvider } from "@tanstack/react-query";
import { useRouter } from "next/router";
import Head from "next/head";
import { Toaster } from "../../../packages/ui/src/components/ui/toaster";
import { initMixpanel, trackPageView } from "@/lib/mixpanelClient";
import { queryClient } from "@/lib/tanstack/query-client";
import { CompanySettingsProvider } from "@/contexts/company-settings-context";
export default function App({
  Component,
  pageProps
}: AppProps) {
  const router = useRouter();
  useEffect(() => {
    initMixpanel(); // Initialize Mixpanel

    const handleRouteChange = (url: string) => {
      trackPageView(url); // Track pageviews
    };

    // Track initial page load
    trackPageView(router.asPath);

    // Track page views on route change
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events, router.asPath]);
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="App" data-sentry-source-file="_app.tsx">
      <CompanySettingsProvider settings={{
      currency: "USD"
    }} data-sentry-element="CompanySettingsProvider" data-sentry-source-file="_app.tsx">
        <Head data-sentry-element="Head" data-sentry-source-file="_app.tsx">
          <title>Copilot CRM Client Portal</title>
          <meta name="description" content="Client portal for home service companies" data-sentry-element="meta" data-sentry-source-file="_app.tsx" />
        </Head>
        <div id="__app_root">
          <Component {...pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
          <Toaster data-sentry-element="Toaster" data-sentry-source-file="_app.tsx" />
        </div>
      </CompanySettingsProvider>
    </QueryClientProvider>;
}